import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { ThemeService } from './core/services/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent implements OnInit {
  private auth = inject(AuthService);
  private theme = inject(ThemeService);

  ngOnInit(): void {
    // reaplica a cor da loja ao recarregar (persistida no login)
    const store = this.auth.store();
    this.theme.applyPrimary(store?.primaryColor ?? '#2196F3');
  }
}
